export const TestimonialCard = (props: { text: string; name: string }) => {
  return (
    <figure className="relative flex flex-col rounded-3xl border border-slate-100 bg-gradient-to-b from-brand-50/60 to-white p-8 shadow-card transition-all duration-300 hover:-translate-y-2 hover:shadow-soft">
      <div className="absolute -top-5 left-8 flex h-11 w-11 items-center justify-center rounded-full bg-brand-700 font-display text-2xl text-white shadow-soft">
        ❝
      </div>
      <blockquote className="mt-4 flex-1 leading-relaxed text-slate-600">
        {props.text}
      </blockquote>
      <figcaption className="mt-6 flex items-center gap-3 border-t border-slate-100 pt-5">
        <span className="flex h-10 w-10 items-center justify-center rounded-full bg-gradient-to-br from-brand-500 to-sea-500 text-sm font-bold text-white">
          {props.name.charAt(0)}
        </span>
        <span className="font-semibold text-slate-900">{props.name}</span>
      </figcaption>
    </figure>
  );
};
